// Employee name normalization. Ported from CPAiSuite Universal (Tech Spec §6.5).
//
// 1. Trim and collapse internal whitespace.
// 2. If no comma: treat as "First Last" and reorder to "Last, First".
// 3. If a comma is present: already "Last, First" — preserve order.
// 4. Title-case each part.
//
// Edge cases (MacDonald, O'Brien, Jr./III) are intentionally NOT special-cased —
// they route through the alias system (Functional Spec §3.5).

function titleCase(part: string): string {
	return part.replace(
		/\S+/g,
		(w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
	);
}

export function normalizeEmployeeName(name: string): string {
	const s = String(name ?? '')
		.trim()
		.replace(/\s+/g, ' ');
	if (s === '') return '';

	if (s.includes(',')) {
		// Already "Last, First" format.
		const commaIndex = s.indexOf(',');
		const last = titleCase(s.slice(0, commaIndex).trim());
		const first = titleCase(s.slice(commaIndex + 1).trim());
		return first ? `${last}, ${first}` : `${last},`;
	}

	// "First [Middle] Last" -> "Last, First [Middle]".
	const parts = s.split(' ');
	if (parts.length === 1) return titleCase(parts[0]);
	const last = parts[parts.length - 1];
	const rest = parts.slice(0, -1).join(' ');
	return `${titleCase(last)}, ${titleCase(rest)}`;
}
